import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const WebDesignPackages = () => {
  useEffect(() => {
    analytics.track('Template Page View', { template: 'Web Design Packages' });
  }, []);

  return (
    <SEOPageLayout
      title="Web Design Proposal Template - Sell Retainers & Packages | QuoteTier"
      description="Stop charging hourly. Use this web design proposal template to sell value-based packages and ongoing maintenance retainers."
      canonical="/templates/web-design-packages-template"
      ogTitle="Web Design Packages That Convert"
      ogDescription="Move from 'How much for a website?' to 'Which growth package do you need?'. Includes hosting, SEO, and maintenance tiers."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              Web Design <span className="text-primary font-bold">Package</span> Template
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              Shift from project-based pricing to recurring revenue. Sell the build + the growth.
            </p>
            <div className="font-instrument mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center mb-6">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Use This Template Free
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">Template Overview</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Launch</CardTitle><CardDescription>Brochure Site</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>5 Page WordPress Site</li>
                      <li>Basic SEO Setup</li>
                      <li>Mobile Responsive</li>
                      <li>Contact Form</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black bg-black text-white">
              <CardHeader><CardTitle className="font-instrument text-xl text-white">Growth</CardTitle><CardDescription className="text-gray-300">Marketing Ready</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-300 list-disc list-inside">
                      <li>10 Page Custom Site</li>
                      <li>CMS Training</li>
                      <li>Blog/News Section</li>
                      <li>Google Analytics Setup</li>
                      <li>Newsletter Integration</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Scale</CardTitle><CardDescription>E-commerce / App</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Full E-commerce Setup</li>
                      <li>Custom Functionality</li>
                      <li>CRM Integration</li>
                      <li>Advanced Automation</li>
                  </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Start Selling Packages</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Get Free Access
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default WebDesignPackages;
